import UnofficialCampaignsAPI from 'dashboard/api/unofficialCampaigns';

export const listUnofficialCampaigns = async () => {
  const response = await UnofficialCampaignsAPI.get();
  return response?.data;
};

export const getUnofficialCampaign = async id => {
  const response = await UnofficialCampaignsAPI.show(id);
  return response?.data;
};

export const createUnofficialCampaign = async payload => {
  const response = await UnofficialCampaignsAPI.create(payload);
  return response?.data;
};

export const updateUnofficialCampaign = async (id, payload) => {
  const response = await UnofficialCampaignsAPI.update(id, payload);
  return response?.data;
};

export const deleteUnofficialCampaign = async id => {
  const response = await UnofficialCampaignsAPI.delete(id);
  return response?.data;
};

const safeJsonParse = value => {
  if (typeof value !== 'string') return value;

  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

export const normalizeUnofficialCampaign = row => {
  const contacts = safeJsonParse(row?.lista_contato);
  const weekdays = safeJsonParse(row?.dias_semana);

  return {
    ...row,
    lista_contato: Array.isArray(contacts) ? contacts : [],
    dias_semana: Array.isArray(weekdays) ? weekdays : [],
  };
};

export const normalizePhoneNumber = phone => {
  const digits = String(phone || '').replace(/\D/g, '');
  if (digits.length < 10) return phone;

  if (!String(phone || '').startsWith('+')) {
    return digits.startsWith('55') ? `+${digits}` : `+55${digits}`;
  }

  return phone;
};

export const toTimeString = value => {
  if (!value) return '';
  if (/^\d{2}:\d{2}:\d{2}$/.test(value)) return value;
  if (/^\d{2}:\d{2}$/.test(value)) return `${value}:00`;
  return value;
};

export const toDatetimeLocal = value => {
  if (!value) return '';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value).slice(0, 16);

  const pad = number => String(number).padStart(2, '0');

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
